import styled from 'styled-components';

export const PageScroll = styled.div`
  width: 100%;
  height: calc(100vh - 30px - 40px - 80px);
  overflow-y: auto;
  padding: 20px 4px 4px;

  ::-webkit-scrollbar {
    width: 8px;
    height: 10px;
    position: relative;
  }
  ::-webkit-scrollbar-track {
    background-color: #e5e5e560;
  }
  ::-webkit-scrollbar-thumb {
    background-color: #04346d;
    border-radius: 3px;
  }
`;

export const BentoGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(12, 1fr);
  gap: 16px;
  width: 100%;
  max-width: 1100px;
  margin: 0 auto;
`;

export const BentoCard = styled.div`
  grid-column: span ${({ $span }) => $span || 12};
  display: flex;
  flex-direction: column;
  background: ${({ theme, $accent }) =>
    $accent ? `${theme.colors.primary}14` : theme.colors.backgroundSecondary};
  border: 1px solid
    ${({ theme, $accent }) => ($accent ? `${theme.colors.primary}30` : 'transparent')};
  border-radius: 18px;
  padding: 20px 22px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.06), 0 1px 10px rgba(0, 0, 0, 0.04);

  @media (max-width: 900px) {
    grid-column: span 12;
  }
`;

export const CardHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 18px;
`;

export const CardIconBadge = styled.div`
  width: 36px;
  height: 36px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
  background: ${({ theme }) => `${theme.colors.primary}1F`};
  color: ${({ theme }) => theme.colors.primary};
`;

export const CardTitleGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
`;

export const CardTitle = styled.span`
  font-size: 14px;
  font-weight: 700;
  color: ${({ theme }) => theme.colors.text};
  text-transform: uppercase;
  letter-spacing: 0.4px;
`;

export const CardSubtitle = styled.span`
  font-size: 12px;
  color: ${({ theme }) => theme.colors.textSecondary};
`;

export const FieldsGrid = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
`;

export const Field = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  flex: ${({ $grow }) => $grow ?? 1};
  min-width: ${({ $minWidth }) => $minWidth || '160px'};

  & .rs-input,
  & .rs-input-group,
  & .rs-picker-toggle {
    border: 1px solid ${({ theme }) => `${theme.colors.textSecondary}4D`} !important;
  }
`;

export const FieldLabel = styled.label`
  display: flex;
  align-items: center;
  gap: 5px;
  font-size: 12px;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.textSecondary};
  text-transform: uppercase;
  letter-spacing: 0.3px;
`;

export const RequiredDot = styled.span`
  width: 4px;
  height: 4px;
  border-radius: 50%;
  background: ${({ theme }) => theme.colors.textSecondary};
  flex-shrink: 0;
`;

export const FieldInputRow = styled.div`
  display: flex;
  gap: 8px;
`;

export const SaveBar = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 10px;
  margin: 16px auto 0;
  max-width: 1100px;
`;
